import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath, ToggleRevealContainerContext, useToggleRevealContainer } from '@uswitch/spark.utils';
import React, { useEffect, useState } from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export { TabButton } from './tab-button';
export { TabIcon } from './tab-icon';
export { TabList } from './tab-list';
export { TabPanel } from './tab-panel';
export { TabPanels } from './tab-panels';
var wrapperVariantPath = getVariantPath({
  id: 'tabs',
  element: 'wrapper'
});
export var Tabs = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "children"]);

  var providerValue = useToggleRevealContainer(true);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hydratedWithReact = _useState2[0],
      setHydratedWithReact = _useState2[1];

  useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
      setHydratedWithReact(true);
    }
  }, []);
  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    "data-spark-tabs": true,
    "data-spark-hydrated": hydratedWithReact,
    sx: {
      variant: wrapperVariantPath()
    },
    children: _jsx(ToggleRevealContainerContext.Provider, {
      value: providerValue,
      children: children
    })
  }));
});